import { Star } from "lucide-react";

export function Stars({ value = 0, size = 16, interactive = false, onChange }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={!interactive}
          onClick={interactive ? () => onChange(n) : undefined}
          data-testid={interactive ? `star-${n}` : undefined}
          style={{ lineHeight: 0, background: "none", border: "none", padding: 0, cursor: interactive ? "pointer" : "default" }}
          aria-label={`${n} étoile${n > 1 ? "s" : ""}`}
        >
          <Star size={size} strokeWidth={1.8} style={{ color: "var(--orange)" }} fill={n <= Math.round(value) ? "var(--orange)" : "none"} />
        </button>
      ))}
    </div>
  );
}
